export default function useQueryBuilder() {
    return {};
};
